import { render } from "./TheSubHeader.vue?vue&type=template&id=4acc8694"
import script from "./TheSubHeader.vue?vue&type=script&lang=js"
export * from "./TheSubHeader.vue?vue&type=script&lang=js"

import "./TheSubHeader.vue?vue&type=style&index=0&id=4acc8694&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__